$(document).ready(function(e){ 
  // Submit the form with an ajax/jsonp request.
  // Based on http://stackoverflow.com/a/15120409/215821
  function submitSubscribeForm($form, $resultElement) {
    $.ajax({
      type: "GET",
      url: $form.attr("action"),
      data: $form.serialize(),
      cache: false,
      dataType: "jsonp",
      jsonp: "c", // trigger MailChimp to return a JSONP response
      contentType: "application/json; charset=utf-8",

      error: function(error){
        // According to jquery docs, this is never called for cross-domain JSONP requests
      },

      success: function(data){
        if (data.result != "success") {
          var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";
          $resultElement.css("color", "#ff5f6a");

          if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
            message = "You're already subscribed. Thank you.";
            $resultElement.css("color", "#ff5f6a");
          }

          $resultElement.html(message);

        } else {
          $resultElement.css("color", "#ff5f6a");
          $resultElement.html("Thank you!");
        }
      }
    });
  }
  // Turn the given MailChimp form into an ajax version of it.
  // If resultElement is given, the subscribe result is set as html to
  // that element.
  function ajaxMailChimpForm($form, $resultElement){

    // Hijack the submission. We'll submit the form manually.
    $form.submit(function(e) {
      e.preventDefault();

      if (!isValidEmail($form)) {
        var error =  "A valid email address must be provided.";
        $resultElement.html(error);
        $resultElement.css("color", "#ff5f6a");
      } else {
        $resultElement.css("color", "#ff5f6a");
        $resultElement.html("Subscribing...");
        submitSubscribeForm($form, $resultElement);
      }
    });
  }
  ajaxMailChimpForm($("#newsletter-form-mailchimp"), $("#subscribe-result"));
  ajaxMailChimpForm($("#newsletter-form-mailchimp1"), $("#subscribe-result1"));

  // Validate the email address in the form
  function isValidEmail($form) {

    // If email is empty, show error message.
    // contains just one @
    var email = $form.find("input[type='email']").val();
    if (!email || !email.length) {
      return false;
    } else if (email.indexOf("@") == -1) {
      return false;
    }

    return true;
  }

  function addToCartSuccess() {
    $.get( "/cart?view=mini", function( data ) {
      $('#crt').html(data);
      $('#crt').removeClass('loading');
    });
  }
  function refreshCart(cart) {
    $('.cart_count').text(cart.item_count);
    $('.head-cart .price').text('$'+cart.total_price / 100);    
  }
  $('body').on('click','.AddToCart',function(e){
    e.preventDefault();
    if($('.AddToCart.is_editable').length){
      return false;
    }
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    btn.text('adding...');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.text('ADD TO CART');
        btn.removeAttr('disabled');
      }

    }).done(function( data ) {
      $('div[data-popup="cart-success"] h3').text(data.title);
      $('div[data-popup="cart-success"]').addClass('popup-active');
      $('.overlay').addClass('popup-active');
      addToCartSuccess();      
      btn.text('Buy Now');
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(cart){
        refreshCart(cart);
      });      
    });
  });

  $("#crt").on('click', "a.remove_item", function(r){
    $('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('.itemCount').text(c.item_count);
      $('.cart_count').text(c.item_count);
      if(!c.item_count) {
        $('#crt').empty();
        $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
        $('#crt').removeClass('has-item');
        $('#crt').removeClass('loading');
        $.getJSON("/cart.js", function(cart) {
          refreshCart(cart);
        });
      } else {
        addToCartSuccess();
      }
    });
    $.getJSON("/cart.js", function(cart) {
      refreshCart(cart);
    });
  });

  $("body").on('click', ".popup-closer,.keep_shop", function(e){
    e.preventDefault();
    var $parents = $('.popup-active').attr('data-popup');
    $(this).closest(".cs-popup").removeClass("popup-active");
    $('.overlay').removeClass("popup-active");
    var video =   document.getElementById($parents);
    if(video){
      video.pause();
    }
  });
  //$('.color_selected input').hide();
  $('.color input').click(function(){
    var radioValue = $(this).val();
    if(radioValue){
      $(this).parent().parent().siblings().children('.color_name').text(radioValue);
    }
  });

  $("a.top-arrow.w-inline-block").on("click", function() {
    $("html").animate({ scrollTop: 0 }, "slow");
  });

  /* homeproduct tab*/ 
  $('a.s8-product-pcs-btn.w-button').click(function(e){
    e.preventDefault();
    $('.s8-filtry-div-desktop .w-col.w-col-4.w-col-stack').removeClass('active');
    var pro=$(this).attr('href');
    $('.s8-filtry-div-desktop '+pro).addClass('active');
    if($('.slider-for').hasClass('slick-initialized')) {
      $('.slider-for').slick('refresh');
    } else {
      $('.slider-for').slick();
    }
    if($('.slider-nav').hasClass('slick-initialized')) {
      $('.slider-nav').slick('refresh');
    } else {
      $('.slider-nav').slick();
    }

  });



  if( jQuery(".tab-content-1").length > 0){
    //Default Action Product Tab
    jQuery(".tab-content-1").hide(); //Hide all content
    jQuery("ul.tabs-1 li:first").addClass("active").show(); //Activate first tab
    jQuery(".tab-content-1:first").show(); //Show first tab content
    //On Click Event Product Tab
    jQuery("ul.tabs-1 li").click(function() {
      jQuery("ul.tabs-1 li").removeClass("active"); //Remove any "active" class
      jQuery(this).addClass("active"); //Add "active" class to selected tab
      jQuery(".tab-content-1").hide(); //Hide all tab content
      var activeTab = jQuery(this).find("a").attr("href"); //Find the rel attribute value to identify the active tab + content
      jQuery(activeTab).fadeIn(); //Fade in the active content
      return false;
    });
  }

  $('.mini-products-list-slider').slick({
    arrows: true,
    //     prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="previous"><img src="https://cdn.shopify.com/s/files/1/0050/1743/6224/files/arrow-left-2.png?15394767956628900959"></button>',
    //     nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="next"><img src="https://cdn.shopify.com/s/files/1/0050/1743/6224/files/arrow-right-2.png?15394767956628900959png"></button>',
    dots: false,
    speed: 1000,
    slidesToShow: 3,
    centerMode:false,
    centerPadding:'0px',
    slidesToScroll: 1,
    vertical:true,
    autoplay: false,
    focusOnSelect: true
  });


  $('body').on('click', '.adjust',function(e){
    e.preventDefault();
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    console.log('IP =', ip);
    input.val(ip);   
  })




  $('.product-image').slick({
    arrows: false,
    dots: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    asNavFor:'.product-feacture-slider'
  });
  $('.product-feacture-slider').slick({
    arrows: true,    
    dots: false,
    speed: 1000,
    slidesToShow: 3,
    centerMode:false,
    centerPadding:'0px',
    slidesToScroll: 1,

    autoplay: false,
    asNavFor:'.product-image',
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });

  $('#contact_form').on('submit',function(){
    var x = true;
    $(this).find('.err-msg').remove();
    var fn = $(this).find('#contactFormName');
    var em = $(this).find('#contactFormEmail');
    var pn = $(this).find('#contactFormMessage');
    if(fn.val().trim() == ''){
      fn.css('border','1px solid #cb2700');
      fn.parent().append('<p class="err-msg">This is a required field.</p>');
      x = false;
    } else {
      fn.css('border','1px solid #000');
      fn.parent().find('.err-msg').remove();
    }

    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if(pn.val().trim() == '' || !phoneno.test(pn.val())) {
      pn.css('border','1px solid #cb2700');
      pn.parent().append('<p class="err-msg">This is a required field.</p>');
      x = false;
    } else {
      pn.css('border-bottom','1px solid #eaeaea');
      pn.parent().find('.err-msg').remove();
    }
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    if(em.val().trim() == '' || !regex.test(em.val())) {
      em.css('border','1px solid #cb2700');
      em.parent().append('<p class="err-msg">This is a required field.</p>');
      x = false;
    } else {
      em.css('border','1px solid #eaeaea');
      em.parent().find('.err-msg').remove();
    }
    if(x==false) {
      return false;
    }
  });




  if($('body').hasClass('template-product')){
    var window_hash = window.location.hash;
    if(window_hash == '#is_edit'){
      var full_url = window.location.href;
      full_url = full_url.split('?');
      full_url = full_url[1].split('&');
      console.log(full_url);
      var item_key = '';
      var item_qty = 0;
      $(full_url).each(function(i,v){
        if(v.indexOf('key') > -1){
          var i_k = v.split('=');
          item_key = i_k[1];
        }else if(v.indexOf('qty') > -1){
          var i_q = v.split('=');
          item_qty = parseInt(i_q[1]);
        }
      });
      if(item_key != '' && item_qty != 0){

        //match QTY Class
        $('input[quantity]').val(item_qty); 

        //match Product Form Class
        $('.product-shop .addtocartForm .AddToCart').addClass('is_editable');
        $('body').on('click','.is_editable',function(e){

          e.preventDefault();
          var btn = $(this);
          var form = $(this).closest('form');
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
              quantity: 0,
              id: item_key
            },
            async: false,
            error: function(jqXHR, textStatus, errorThrown){
              var response = $.parseJSON(jqXHR.responseText);
              console.log('error');
              console.log(response.description);
            },
            success: function success(cart) {
              console.log('item removed success');
              $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                data: form.serialize(),
                dataType: 'json',
                error: function(jqXHR, textStatus, errorThrown){
                  var response = $.parseJSON(jqXHR.responseText);
                  form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
                  btn.text('Buy Now');
                  btn.removeAttr('disabled');
                }
              }).done(function( data ) {
                $('div[data-popup="cart-success"] h3').text(data.title);
                $('div[data-popup="cart-success"]').addClass('popup-active');
                $('.overlay').addClass('popup-active');
                addToCartSuccess();      
                btn.text('Buy Now');
                btn.removeAttr('disabled');
                $.getJSON('/cart.js', function(cart){
                  refreshCart(cart);
                });  
                window.location = '/cart';
              });

            }
          });
        });        
      }
    }
  }


  function closePopup() {
    $('.popupBox').removeClass('slideInDown');
    $('.popupBox').addClass('slideOutUp');
    $('.popupOverlay').fadeOut('slow');
  }
  function openPopup(a) {
    $('.popupBox').addClass('slideInDown');
    $('.popupBox').removeClass('slideOutUp');
    $('.popupOverlay.'+a).fadeIn('slow');
  }
  $('body').on('click','.popupinfo',function(e){
    e.preventDefault();
    var id = $(this).data('href');
    openPopup(id);
  });
  $('body').on('click','.cls_popup',function(e){
    e.preventDefault();
    closePopup();
  });
  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      closePopup();
    }
  });
  window.onclick = function(e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }
  }


  /* Quick VIew */
  $('.openQv').on('click', function(e){
    $(this).attr('disabled','disabled');
    $('.qvProduct').removeAttr('style');
    var url = $(this).attr("href");
    e.preventDefault();
    $.get( url, function( data ) {
      $('#qvProductContent').html(data);
      openPopup('qvPopup');
      $('.puList').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false
      });

      $('.qv_main').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.qv_thumb'
      });
      $('.qv_thumb').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.qv_main',
        dots: false,
        focusOnSelect: true,
        arrows: true,
      });

      $('.addtocartForm').on('submit', function(e){
        e.preventDefault();
        $('#AddToCart').attr('disabled');
        $('#AddToCart span').text('Adding..');
        var form = $(this);
        $('.puadd:checked').each(function(){
          var id = $(this).attr('data-id');
          $.ajax({
            url: '/cart/add.js',
            data: { id: id },
            type: 'POST',
            dataType: 'json',
            async:false
          });
        });
        $.ajax({
          url: '/cart/add.js',
          data: form.serialize(),
          type: 'POST',
          dataType: 'json',
          async:false,
          success: function(){
            $('#AddToCart').removeAttr('disabled');
            $('#AddToCart span').text('Buy Now');            
            closePopup();
            addToCartSuccess();
            $.getJSON('/cart.js', function(cart){
              refreshCart(cart);
            });
            $('.productGrid .productItem').removeClass('qvopen');
            $('body').addClass('cartOpen');
            $('.fullPage').addClass('witmenu');
          }
        });
      });

    });
    $('.openQv').removeAttr('disabled');
  });
  /* Quick View */
  $('body').on('click','.Apply-Coupon .button',function(e){    
    e.preventDefault();
    $('input.btn1.cart__submit.btn.btn--secondary').trigger('click');
  })  
  
  
  $( ".head-cart" ).click(function() {
    $( ".mini-cart" ).toggle('slow');
  });
  
  $( ".search-click" ).click(function() {
    $( ".form-search" ).toggle();
  });
  $( ".menu-icon" ).click(function() {
    $( ".main-nav" ).slideToggle(500);
  });

});

function doShowReviewform(e){
  $('#tabs2').trigger('click');
}  

$(window).scroll(function(){
    if ($(this).scrollTop() > 149) {
       $('.nav-main').addClass('stick');
    } else {
       $('.nav-main').removeClass('stick');
    }
});